import { ClaimItReferral } from "../models/claim-it-referral.model";
import { DataSource } from "@angular/cdk/collections";
import { concatMap, Observable, Subject, takeUntil, timer } from "rxjs";
import { OpportunityService } from "../services/opportunity.service";

export class AvailableReferralDatasource extends DataSource<ClaimItReferral> {
  private onDestroy$: Subject<boolean> = new Subject();
  private readonly sortField: string | null = null;
  private readonly sortOrder: string | null = null;
  private readonly pageNumber: number = 0;
  private readonly pageSize: number = 10;
  private readonly timerInterval: number = -1;

  constructor(
    private opportunityService: OpportunityService,
    sortField: string | null,
    sortOrder: string | null,
    pageNumber: number,
    pageSize: number,
    timerInterval?: number | undefined
  ) {
    super();
    this.sortField = sortField;
    this.sortOrder = sortOrder;
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    // timerInterval is optional. If timerInterval is set to a positive number the datasource will be refreshed every X
    // milliseconds where X is the timerInterval. If timerInterval is negative or undefined only one datasource request
    // will occur.
    this.timerInterval = timerInterval != null ? timerInterval : -1;
  }

  connect(): Observable<ClaimItReferral[]> {
    return timer(0, this.timerInterval).pipe(
      takeUntil(this.onDestroy$),
      concatMap(
        (): Observable<ClaimItReferral[]> =>
          this.opportunityService.getAvailableReferrals(
            this.sortField,
            this.sortOrder,
            this.pageNumber,
            this.pageSize
          )
      )
    );
  }

  disconnect(): void {
    if (this.timerInterval >= 0) {
      this.onDestroy$.next(true);
    }
  }
}
